export const mutations = {
  addSaleItems(state) {
    state.sale_items.push({
      product_id: "",
      truck_id: "",
      product_measurement: "",
      balance_stock: "",
      qty: "",
      unit_price: "",
      total_price: "",
      remark: ""
    });
  },

  STORE_SALES(state, sales) {
    state.sales = sales;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/sales/mutations.js